import { UnhandledError } from '../errors';
const rethrow = (err, isAsync = false) => {
  setTimeout(() => {
    throw new UnhandledError(isAsync ? UnhandledError.Reason.ASYNC_ERROR : UnhandledError.Reason.ERROR, {
      messageArgs: [err],
      originalError: err
    });
  }, 0);
};
export function safeCallback(fn) {
  const wrapped = (...args) => {
    try {
      const result = fn(...args);
      if (result instanceof Promise) {
        return result.then(() => undefined).catch(err => {
          rethrow(err, true);
        });
      }
    } catch (err) {
      rethrow(err, false);
    }
  };
  return wrapped;
}